import React from 'react';
import { Grid } from '@material-ui/core';

import { useStyles } from './styles';

interface Props {
  alignLeft?: boolean;
}

const Icon: React.SFC<Props> = (props) => {
  const { alignLeft, children } = props;
  const classes = useStyles({ alignLeft });

  return (
    <Grid item lg={2} md={2} sm={2} xs={3}>
      <div className={classes.iconPadding}>
        <div className={classes.iconCircle}>
          {children}
        </div>
      </div>
    </Grid>
  );
}

export default Icon;
